import { OneOrManySchema, SortModelSchema } from 'notable-common';
import { z } from 'zod';
import { HumanTaskState } from './state.js';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
import { FlowRpaJobKind } from '../rpaJob/rpaJob.js';
export const HumanTaskFindAllQuerySchema = z
    .object({
    agentId: z.uuid(),
    flowRunId: z.uuid(),
    flowId: OneOrManySchema(z.uuid()),
    entityId: OneOrManySchema(z.uuid()),
    organizationId: OneOrManySchema(z.uuid()),
    states: z.array(z.enum(HumanTaskState)).optional(),
    categoryId: OneOrManySchema(z.uuid()),
    assignedToId: OneOrManySchema(z.uuid()),
    workflowTransitionRpaJobKind: z.enum(FlowRpaJobKind).optional(),
    tags: OneOrManySchema(z.string()).optional(),
    q: z.string(),
    createdAfter: z.iso.datetime(),
    createdBefore: z.iso.datetime(),
    expiresAfter: z.iso.datetime(),
    expiresBefore: z.iso.datetime(),
    limit: FlowApiPageLimitSchema,
    offset: FlowApiPageOffsetSchema,
    sortModel: SortModelSchema,
})
    .partial();
export const HumanTaskClaimNextQuerySchema = HumanTaskFindAllQuerySchema.omit({
    states: true,
    limit: true,
    offset: true,
});
//# sourceMappingURL=query.js.map